<template>
    <div class="col backgroundForm">
        <div class="col-md-6 offset-md-3">
            <div class="alert alert-info" align="center" role="alert">
                <h4 class="alert-heading">Ordenes de Operaciones</h4>
                <p>Certificaciones de Ordenes de Operaciones por Persona</p>        
            </div>
        </div>
        
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-add-capitan" data-toggle="tab" href="#nav-print-cert" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="user-plus" /> Certificacion Individual</a>
                <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-reprint-cert" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="file-pdf" /> Reimpresion Certificaciones</a>
            </div>
        </nav>
                
        <div class="tab-content" id="nav-tabContent">                
            <div class="tab-pane fade show active" id="nav-print-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br><br>
                <h6 align="center">Busqueda y Certificacion de Personas</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="person_edit.id > 0" class="panel panel-default">
                        <div class="form-row">
                        <div class="form-group col-12 col-md-3">
                            <label for="type_identification" class="badge badge-primary">Identificacion</label>
                            <div>
                              <input type="text" readonly class="form-control-plaintext" id="staticID" v-model="person_edit.number_identification">
                            </div>
                        </div>

                        <div class="form-group col-12 col-md-2">
                            <label for="number_identification" class="badge badge-primary">Grado </label>
                            <div>
                              <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="person_edit.grade">
                            </div>
                        </div>

                        <div class="form-group col-12 col-md-2">
                            <label for="site_expedition" class="badge badge-primary">Especialidad </label>
                            <div>
                              <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="person_edit.speciality">
                            </div>
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="owner_name" class="badge badge-primary">Nombre y Apellidos</label>
                            <div>
                              <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="person_edit.complete">
                            </div>
                        </div>
                        <div class="col-md-1">
                            <button class="btn btn-danger" @click="mCloseEdit"><font-awesome-icon icon="times-circle" size="2x" /></button>    
                        </div>
                        
                    </div>
                    <hr>
                    <h6>Busqueda de Ordenes de Operaciones</h6>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="date_init_ordop">Del : </label>
                            <datetime v-model="dts_millas.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="date_init_ordop">Al : </label>
                            <datetime v-model="dts_millas.date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                    </div>
                    
                    <button class="btn btn-outline-info col-12 col-md-4 offset-md-4" @click="mBuscaOrdopsPersona"> Buscar ORDOPS <font-awesome-icon icon="search" /></button>

                    
                    <!-- AQUI VA EL FORMULARIO QUE PERMITIRA SELECCIONAR LAS ORDOPS VIGENTES Y LOS DATOS DE LAS PERSONAS QUE FIRMARAN EL DOCUMENTO -->
                    <br><br>
                    
                    <table class="table table-sm" v-if="ordops_persona.length > 0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Gestion</th>
                                <th>ORDOP</th>
                                <th>TIPO</th>
                                <th>MILLAS</th>
                                <th>Unidad</th>
                                <th>Sistema</th>
                                <th>Adjunto</th>
                                <th><font-awesome-icon icon="check" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(orr,index) in ordops_persona" :key="orr.id_ordop">
                                <td>{{ index+1 }}</td>
                                <td>{{ orr.gestion }}</td>
                                <td>{{ orr.titulo_ordop }}</td>
                                <td>{{ orr.tipo_ordop }}</td>
                                <td>{{ orr.millas_navigate }}</td>
                                <td>{{ orr.name_port }}</td>
                                <td>
                                    <button class="btn btn-outline-success"  @click="mReportI(orr.id_ordop)"><font-awesome-icon icon="file-pdf" /></button>
                                </td>
                                <td>
                                    <button class="btn btn-outline-info" :disabled="orr.archivo_registrado==='N' ? true:false" @click="mVerDocumento(orr.id_ordop)"><font-awesome-icon icon="file-pdf" /></button>
                                </td>
                                <td>
                                    <div v-if="orr.archivo_registrado==='S'">
                                        <input type="checkbox" :id="orr.id_download" :value="orr" name="customCheck" v-model="orr.select" @click="mCheckChange($event, orr)">
                                    </div>
                                    <span v-else>S/R</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <!-- este div contiene el formulario de firmas rubrica, motivo y tipo de certificacion -->
                    <div v-if="ordops_seleccionados.length > 0">
                        <!-- aqui un boton para recuperar el ultimo registro de quien firmo -->
                         
                        <div class="input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">Jefe Departamento</span>
                            </div>
                            
                            <div class="input-group-prepend">
                                <select name="grado" id="grado" class="form-control" v-model="dts_certificado.id_grado_jefe">
                                    <option v-for="gr in grados" :value="gr.id" :key="gr.id">{{gr.detail}}</option>
                                </select>
                            </div>
                            
                            <div class="input-group-prepend">
                                <select name="especialidad" id="especialidad" class="form-control" v-model="dts_certificado.id_especialidad_jefe">
                                    <option v-for="esp in especialidad" :value="esp.id" :key="esp.id">{{esp.detail}}</option>
                                </select>
                            </div>
                            
                            <input type="text" class="form-control" id="staticEmail" v-model="dts_certificado.jefe" autocomplete="off">
                        </div>
                        
                        <div class="input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">SubJefe Departamento</span>
                            </div>
                            <input type="text" class="form-control" id="staticEmail" v-model="dts_certificado.subjefe" autocomplete="off">
                        </div>
                        
                        <div class="input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">Jefe División</span>
                            </div>
                            <input type="text" class="form-control" id="staticEmail" v-model="dts_certificado.division" autocomplete="off">
                            
                            <div class="input-group-prepend" v-if="is_administrador">
                                <select name="division" id="division" class="form-control" v-model="aux_division">
                                    <option v-for="dr in divisiones" :value="dr" :key="dr.id">{{dr.detail}}</option>
                                </select>
                            </div>
                            <div class="input-group-prepend" v-else>
                                <input type="text" class="form-control-readonly" id="staticEmail" v-model="aux_division.detail" disabled="disabled" autocomplete="off">
                            </div>
                            
                        </div>                        
                        
                        <div class="form-row">
                            <div class="form-group col-12 col-md-8">
                                <label for="owner_name" class="badge badge-primary">TIPO CERTIFICADO</label>
                                <div>
                                    <select name="tipo_certificado" id="tipo_certificado" class="form-control" v-model="dts_certificado.tipo_certificado">
                                        <option v-for="tco in tipos_certificado" :key="tco.id" :value="tco.id" >{{tco.detail}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="owner_name" class="badge badge-primary">RUBRICAS</label>
                                <div>
                                    <input type="text" class="form-control" id="staticEmail" v-model="dts_certificado.rubrica" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        
                        <div class="form-row">
                            <div class="form-group col-12 col-md-8">
                                <label for="owner_name" class="badge badge-primary">Motivo Solicitud</label>
                                <div>
                                    <input type="text" class="form-control" id="staticEmail" v-model="dts_certificado.motivo_solicitud" autocomplete="off">
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <button class="btn btn-outline-warning" :disabled="correlative.co>0 ? true:false" @click="mRecuperaDatos"><font-awesome-icon icon="arrows-alt-h" size="4x" /></button>
                            </div>
                        </div>

                        <div class="input-group col-8 offset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">Correlativo Certificado</span>
                            </div>
                            <input type="text" class="form-control" disabled="disabled" v-model="correlative.co">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" @click="mGenerateCorrelative" type="button" :disabled="correlative.co>0"><font-awesome-icon icon="sync-alt" /></button>
                            </div>
                        </div>
                        <br><br>
                        
                        <div v-if="correlative.co>0">
                            <button class="btn btn-warning col-12 col-md-2 offset-md-4" @click="mSelectPersonReportCaratula()" :disabled="correlative.co===0"><font-awesome-icon icon="file-pdf" size="2x" /> Caratula</button>
                            <button class="btn btn-info col-12 col-md-2" @click="mReportPersonOrdop()" :disabled="correlative.co===0"><font-awesome-icon icon="file-pdf" size="2x" /> Certificado</button>
                        </div>
                        <button class="btn btn-danger col-12 col-md-2" @click="mCloseEdit"><font-awesome-icon icon="times-circle" size="2x" :spin="animate" /></button>
                    </div>
                    
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch"  value="document" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="name">No. Documento
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombreEmbarcacion">{{ searchType }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_person" :placeholder="searchType" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchType }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaData">Buscar</button>

                        <div class="table-responsive" v-if="list_person_ordop.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>CI</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(persReg, index) in list_person_ordop" :key="persReg.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ persReg.complete }}</span>
                                        </td>
                                        <td>{{ persReg.identification }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectPersonReport(persReg)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
            </div>
            <!-- end first tab -->
            
            <div class="tab-pane fade show" id="nav-reprint-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br><br>
                <h6 align="center">Reimpresion de Certificados</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="date_init_ordop">Del : </label>
                            <datetime v-model="dts_reprint.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="date_init_ordop">Al : </label>
                            <datetime v-model="dts_reprint.date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                    </div>
                    
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="mListCertificates">Buscar</button>

                        <div class="table-responsive" v-if="list_reprint.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>División</th>
                                        <th>Certificado</th>
                                        <th>Correlativo</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(persReg, index) in list_reprint" :key="persReg.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ persReg.completo_persona }}</span>
                                        </td>
                                        <td>{{ persReg.division }}</td>
                                        <td>{{ persReg.certificado }}</td>
                                        <td>{{ persReg.correlativo }}/{{ persReg.gestion }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectPersonReportReprintCaratula(persReg.id)">
                                                <font-awesome-icon icon="file-pdf"/>
                                            </button>
                                            <button class="btn btn-outline-success" @click="mSelectPersonReportReprint(persReg.id)">
                                                <font-awesome-icon icon="file-pdf"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
            </div>
            <!-- tab de reimpresion certificado -->
            
        </div>
        <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
    </div>
    </template>
    
    <script>
    import Vue from 'vue';
    import axios from 'axios';
    import modalLoading from '../modal/modalLoading';
    const qs = require('qs');
    
    export default {
        name:'admin-user',
        data(){
            return{
                grados:[],
                especialidad:[],
                ordops_persona:[],
                ordops_seleccionados:[],
                tipos_certificado:[],
                dts_certificado:{
                    rubrica:'',
                    id_grado_jefe:0,
                    id_especialidad_jefe:0,
                    jefe:'',
                    subjefe:'',
                    division:'',
                    tipo_certificado:0,
                    motivo_solicitud:'',
                    id_division:0,
                    detalle_division:''
                },
                aux_division:{
                    id:0,
                    detail:''
                },
                animate:false,
                owner:{
                    id:0,
                    type_identification:null,
                    number_identification:null,
                    site_expedition:null,
                    name:null,
                    direction:null,
                    mobile:null,
                    phone:null,
                    partner:null,
                    nationality:null
                },
                person_edit:{
                    id:0,
                    complete:null,
                    identification:null,
                    site_expedition:null,
                    birthday:null,
                    grade:null,
                    phone:0,
                    speciality:null
                },
                list_person_ordop:[],
                d_owner_disabled:false,
                d_disabled_partner:false,
                d_owner_disabled_edit:false,
                d_disabled_partner_edit:false,
                types_identification:[],
                citys:[],
                countrys:[],
                status_send:true,
                modal_load_id:'id_owner_new',
                modal_load_title:'Cargando', 
                optionSearch:'name',
                data_person:null,
                dts_millas:{
                    date_init:null,
                    date_end:null
                },
                dts_reprint:{
                    date_init:null,
                    date_end:null
                },
                correlative:{
                    co:0,
                    gestion:0,
                    id:0
                },
                list_reprint:[],
                divisiones:[],
                is_administrador:false
            }
        },
        mounted(){
            this.getYears();
            this.chargeInit();
        },
        methods:{
            mReportI(id){
                // console.log(`el id es ${id}`);
                // this.title_modal='Descargando';
                
                // let route = this.$router.resolve({path: `pdfOrdopI/${id}?api_token=${Vue.auth.getToken()}`});
                let url_report=btoa(`pdfOrdopI/${id}`)
                let route = this.$router.resolve({path: `/report/${url_report}`});
                // let route = this.$router.resolve('/link/to/page'); // This also works.
                // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            },
            async mVerDocumento(idTask){
                console.log('viendo el documento adjunto de la ORDOP')
                let url_report=btoa(`pdfDocument/${idTask}`)
                let route = this.$router.resolve({path: `/report/${url_report}`});
                // let route = this.$router.resolve('/link/to/page'); // This also works.
                // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            },
            async mRecuperaDatos(){
                if(this.aux_division.id!==0){
                    let datos_certificado=await axios.get(`recuperaDatos/${this.aux_division.id}?api_token=${Vue.auth.getToken()}`);
                    console.log(datos_certificado);
                    this.dts_certificado.jefe=datos_certificado.data.director;
                    this.dts_certificado.id_grado_jefe=datos_certificado.data.id_grado_jefe;
                    this.dts_certificado.id_especialidad_jefe=datos_certificado.data.id_especialidad_jefe;
                    this.dts_certificado.subjefe=datos_certificado.data.subjefe;
                    this.dts_certificado.division=datos_certificado.data.jefe_division;
                    this.dts_certificado.rubrica=datos_certificado.data.rubrica!==null ?datos_certificado.data.rubrica:'';
                    this.dts_certificado.motivo_solicitud= datos_certificado.data.motivo_solicitud;
                }else{
                    toastr.warning('Seleccione una Division para completar los datos');
                }
            },
            async mCheckChange(event, dts){
                // aqui va al array de ordops elegidas
                if(event.target.checked){
                    this.ordops_seleccionados.push(dts);    
                    // this.$store.dispatch('sDebtsP/addDebts', dts);
                }else{
                    // this.$store.dispatch('sDebtsP/deleteItemDebts', event.target.id);
                    let ib= this.ordops_seleccionados.findIndex(dta=> dta.id_ordop === dts.id_ordop);
                    this.ordops_seleccionados.splice(ib, 1);
                }
                console.log(this.ordops_seleccionados);
            },
            async mBuscaOrdopsPersona(){
              //aqui buscamos a la persona y las ordenes de operaciones finalizadas comprendidas en el periodo señalado
              let aux_init= this.dts_millas.date_init.split('T');
              let aux_end= this.dts_millas.date_end.split('T');
              
               let reso= await axios.get(`ordopsIndividuallyDivision/${this.person_edit.number_identification}/${aux_init[0]}/${aux_end[0]}/${this.aux_division.id}/S?api_token=${Vue.auth.getToken()}`);
               console.log(reso);
               if(reso.data.length>0){
                   this.ordops_persona=reso.data;
               }else{
                toastr.warning(`No se ha encontrado registros de la persona señalada en el periodo indicado`);
               }
            },
            mValidaCorrelativo(){
              if(this.dts_certificado.jefe.trim()===''){
                toastr.warning(`Indique el Nombre del Jefe de Departamento que firma`);
                return false;
              }
              if(this.dts_certificado.id_grado_jefe===0){
                toastr.warning(`Seleccione el grado correspondiente al Jefe de Departamento`);
                return false;
              }
              if(this.dts_certificado.id_especialidad_jefe===0){
                toastr.warning(`Selecciona la especialidad correspondiente al Jefe de Departamento`);
                return false;
              }
              if(this.dts_certificado.subjefe.trim()===''){
                toastr.warning(`Indique el Nombre del Sub-Jefe de Departamento que firma`);
                return false;
              }  
              if(this.dts_certificado.division.trim()===''){
                toastr.warning(`Indique el Nombre del Jefe de División que firma`);
                return false;
              }
              if(this.dts_certificado.motivo_solicitud.trim()===''){
                toastr.warning(`Indique Cual es el motivo de la solicitud de certificación`);
                return false;
              }
              if(this.dts_certificado.tipo_certificado===0){
                toastr.warning(`Seleccione un tipo de certificado`);
                return false;
              }
              
              if(this.dts_certificado.rubrica.length === 0 || this.dts_certificado.rubrica.trim() === ''){
                toastr.warning(`Indique las rubricas del certificado`);
                return false;
              }
              
              if(this.aux_division.id===0){
                toastr.warning(`Seleccione una Division para registrar la certificación`);
                return false;
              }
              
              return true;  
            },
            async mGenerateCorrelative(){
                // esta funcion registrara todo el certificado a generar en base de datos firma director, subjefe y otros
                if(this.mValidaCorrelativo()){
                    let dts={
                        id_person:this.person_edit.id,
                        complete:`${this.person_edit.grade} ${this.person_edit.speciality} ${this.person_edit.complete}`,
                        motivo:this.dts_certificado.motivo_solicitud,
                        fi:this.dts_millas.date_init,
                        ff:this.dts_millas.date_end,
                        jefe:this.dts_certificado.jefe,
                        id_grado_jefe:this.dts_certificado.id_grado_jefe,
                        id_especialidad_jefe:this.dts_certificado.id_especialidad_jefe,
                        subjefe:this.dts_certificado.subjefe,
                        division: this.dts_certificado.division,
                        rubrica: this.dts_certificado.rubrica,
                        tipo_certificado: this.dts_certificado.tipo_certificado,
                        ordops_seleccionadas:this.ordops_seleccionados,
                        id_division:this.aux_division.id,
                        detalle_division:this.aux_division.detail
                    }
                    let genCorrelative=await axios.post(`generateCorrelativeOrdop?api_token=${Vue.auth.getToken()}`,qs.stringify(dts));

                    // console.log(genCorrelative);
                    if(genCorrelative.data.status){
                        toastr.success('Exito', genCorrelative.data.respuesta);
                        this.correlative.co=genCorrelative.data.registro[0].correlativo;
                        this.correlative.gestion=genCorrelative.data.registro[0].gestion;
                        this.correlative.id=genCorrelative.data.registro[0].id;

                    }else{
                        toastr.error('Error', genCorrelative.data.respuesta);
                    }    
                }
                
            },
            getYears(){
                let ya=new Date();
                this.year_select=ya.getFullYear();
                this.month_select=ya.getMonth()+1;
                const init=2018;
                this.years=[];
                for(let i=init; i<=this.year_select; i++){
                    let ai={c:i};
                    this.years.push(ai);
                }
                let  today = new Date();
                let m = today.getMonth() + 1;
                let mes = (m < 10) ? '0' + m : m;
                let d = today.getDate();
                let dia= (d < 10) ? '0'+d : d;
                let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
                this.dts_millas.date_init=date_aux;
                this.dts_millas.date_end=date_aux;
                this.dts_reprint.date_init=date_aux;
                this.dts_reprint.date_end=date_aux; 
                // this.dts_millas.date_init=`${ya.getFullYear()}-${ya.getDay()}-${ya.getMonth()}`;
            },
            async chargeInit(){
                this.tipos_certificado=[];

                let respCert=await axios.get(`globals/tipocertificado?api_token=${Vue.auth.getToken()}`);
                let divisiones = await axios.get(`globals/divisiones?api_token=${Vue.auth.getToken()}`);
                let grados_aux= await axios.get(`globals/grade?api_token=${Vue.auth.getToken()}`);
                let especialidad_aux= await axios.get(`globals/especiality?api_token=${Vue.auth.getToken()}`);
                // console.log(respCert.data);
                if(respCert.data.length>0){
                    this.tipos_certificado=respCert.data;
                    this.divisiones=divisiones.data;
                    this.grados=grados_aux.data;
                    this.especialidad=especialidad_aux.data;
                }else{
                    this.toastr.warning('Sin datos', 'No se ha encontrado Datos registrados en estas fechas')
                }
                // aqui registramos el valor de la certificacion si es administrador o de la division para certificacion
                setTimeout(() => {
                    switch(this.cDtsUser.roleAssign){
                        case 'DIVISION BRAVO':
                            this.title_page='DIVISION BRAVO'
                            console.log(divisiones.data);
                            let idxb=divisiones.data.findIndex((dt)=>dt.short_detail==='DIV. "B"');
                            console.log(idxb);
                            this.aux_division.id=divisiones.data[idxb].id;
                            this.aux_division.detail=divisiones.data[idxb].detail;
                            console.log(this.aux_division);
                            this.is_administrador=false;
                        break;
                        
                        case 'DIVISION DELTA':
                            this.title_page='DIVISION DELTA'
                            let idxd=divisiones.data.findIndex((dt)=>dt.short_detail==='DIV. "D"');
                            this.aux_division.id=divisiones.data[idxd].id;
                            this.aux_division.detail=divisiones.data[idxd].detail;
                            this.is_administrador=false;
                        break;
                        
                        default:
                            this.title_page='ADMINISTRADOR'
                            this.is_administrador=true;                    
                        break;
                    }    
                }, 700);
                
            },
            async mListCertificates(){
                this.list_reprint=[];
                let respCert;
                if(this.is_administrador){
                     respCert=await axios.get(`getCorrelativeCertificate/${this.dts_reprint.date_init}/${this.dts_reprint.date_end}/0?api_token=${Vue.auth.getToken()}`);
                    
                }else{
                    
                    respCert=await axios.get(`getCorrelativeCertificate/${this.dts_reprint.date_init}/${this.dts_reprint.date_end}/${this.aux_division.id}?api_token=${Vue.auth.getToken()}`);
                }
                console.log(respCert.data);
                if(respCert.data.length>0){
                    this.list_reprint=respCert.data;
                }else{
                    toastr.warning('No se ha encontrado Certificados registrados en estas fechas', 'Sin datos')
                }
            },
            mSelectPersonReportReprintCaratula(idR){
                if(idR!==0){
                    let url_report;
                    // let adi=this.dts_millas.date_init.split('T');
                    // this.dts_millas.date_init=adi[0];
                    // let adf=this.dts_millas.date_end.split('T');
                    // this.dts_millas.date_end=adf[0];

                    // u=`pdfEnrollmentShip/${idb}`;
                    // u=`pdfOrdopGral/${this.captain_report_ordop}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`;
                    url_report=btoa(`pdfMillasICVCaratula/${idR}`);
                    let route = this.$router.resolve({path: `/report/${url_report}`});
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                    window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
                }else{
                    toastr.warning('seleccione una persona', 'Advertencia');
                }
            },
            mSelectPersonReportReprint(idR){
                if(idR!==0){
                    let url_report;
                    // let adi=this.dts_millas.date_init.split('T');
                    // this.dts_millas.date_init=adi[0];
                    // let adf=this.dts_millas.date_end.split('T');
                    // this.dts_millas.date_end=adf[0];

                    // u=`pdfEnrollmentShip/${idb}`;
                    // u=`pdfOrdopGral/${this.captain_report_ordop}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`;
                    url_report=btoa(`pdfMillasICV/${idR}`);
                    let route = this.$router.resolve({path: `/report/${url_report}`});
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                    window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
                }else{
                    toastr.warning('seleccione una persona', 'Advertencia');
                }
            },
            
            mSelectPersonReportCaratula(idR){
                if(this.correlative.id!==0){
                    let url_report;
                    // u=`pdfEnrollmentShip/${idb}`;
                    // u=`pdfOrdopGral/${this.captain_report_ordop}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`;
                    url_report=btoa(`pdfMillasICVCaratula/${this.correlative.id}`);
                    let route = this.$router.resolve({path: `/report/${url_report}`});
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                    window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
                }else{
                    toastr.warning('Genere el correlativo de la certificación', 'Advertencia');
                }
            },
            
            mReportPersonOrdop(idP=0){
            // aqui llamamos al reporte de millas de la persona de la CC.PP
                if(this.correlative.id!==0){
                    let url_report;
                    let adi=this.dts_millas.date_init.split('T');
                    this.dts_millas.date_init=adi[0];
                    let adf=this.dts_millas.date_end.split('T');
                    this.dts_millas.date_end=adf[0];

                    // u=`pdfEnrollmentShip/${idb}`;
                    // u=`pdfOrdopGral/${this.captain_report_ordop}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`;
                    url_report=btoa(`pdfMillasICV/${this.correlative.id}`);
                    let route = this.$router.resolve({path: `/report/${url_report}`});
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                    window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
                }else{
                    toastr.warning('seleccione una persona', 'Advertencia');
                }
            },
            mReportPersonOrdopCaratula(idP=0){
                
            },
            mCloseEdit(){
                this.person_edit.id=0;
                this.person_edit.type_identification=0;
                this.person_edit.number_identification=0;
                this.person_edit.site_expedition=0;
                this.person_edit.name=null;
                this.person_edit.direction=null;
                this.person_edit.mobile=null;
                this.person_edit.phone=null;
                this.person_edit.partner=null;
                this.person_edit.nationality=0;
                this.ordops_seleccionados=[];
                this.ordops_persona=[];
                this.correlative.co=0;
                this.correlative.gestion=0;
                this.correlative.id=0;
            },
            mSelectPersonReport(sp){
                this.person_edit.id=sp.id;
                this.person_edit.number_identification=sp.identification;
                this.person_edit.complete=sp.complete;
                this.person_edit.mobile=sp.phone;
                this.person_edit.speciality=sp.speciality;
                this.person_edit.grade=sp.grade;
                // this.mChangeOwnerIdentificationEdit();
            },
            buscaData(){
                // console.log(`${this.optionSearch} tipo`);
                // console.log(`${this.data_person}`);
                this.ordops_persona=[];
                this.ordops_seleccionados=[];
                if(this.data_person !== null || this.data_person.trim().length > 0 ){
                    // console.log('enviando al servidor');
                    axios.get(`searchPersonCompleteType/${this.data_person}/${this.optionSearch}?api_token=${Vue.auth.getToken()}`)
                        .then((res) => {     
                            // console.log(res.data);               
                            this.list_person_ordop = res.data
                            // this.users = res.data.items
                        }).catch(error => {
                            console.log(error);
                        })
                }else{
                    toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
                }
            },
            mViewSearch(event){
                console.log(event);
                var radios=$("input[type=radio]").parents('label');
                let radioV;                
                    for(let i=0;i<radios.length;i++){                    
                        if($(radios[i]).hasClass('active')){
                            radioV=$(radios[i]).children('input').attr('value');
                        }
                    }
                //console.log(radioV);
                this.optionSearch=radioV;
            },
            mProgressModal(){
                $('#'+this.modal_load_id).modal('show');
            },
            mCloseProgressModal(){
                $('#'+this.modal_load_id).modal('hide');
            },
            mSelectedOwner(data){
                // console.log(data);
                this.owner.id=data.id_propietario;
                this.owner.type_identification=data.tipo_identificacion;
                this.owner.number_identification=data.dato_identificacion;
                this.owner.site_expedition=data.id_expedido;
                this.owner.name=data.nombre_propietario;
                this.owner.direction=data.domicilio;
                this.owner.mobile=data.celular;
                this.owner.phone=data.telefono_fijo;
                this.owner.partner=data.representante_legal;
                this.owner.nationality=data.id_nacionalidad;
                this.d_owner_disabled=true;
                this.d_disabled_partner=true;
            },
            mResetRegisterOwner(){
                this.owner.id=0;
                this.owner.type_identification=null;
                this.owner.number_identification=null;
                this.owner.site_expedition=null;
                this.owner.name=null;
                this.owner.direction=null;
                this.owner.mobile=null;
                this.owner.phone=null;
                this.owner.partner=null;
                this.owner.nationality=null;
                this.d_owner_disabled=false;
                this.d_disabled_partner=false;
                this.ordops_seleccionados=[];
            },
            
        },
        components:{
            'modal-loading':modalLoading
        },
        computed:{
            searchType(){
                switch(this.optionSearch){
                    case 'name':
                        return 'Nombre de la Persona';
                    break;
    
                    case 'document':
                        return 'Documento de la Persona';
                    break;
                }
            },
            cDtsUser(){
                return this.$store.getters.getUserState;
            },
        },
        filters:{
            upperCase(value){
                return value.toUpperCase();
            }
        }
    }
    </script>
    
    <style>
        .required-text{
            color:red; 
            font-weight:bold;
        }
    </style>
    


// WEBPACK FOOTER //
// src/components/ordop/OrdopMillasPersonal.vue